// The product writes the euro area as EA, which in ISO 3166 is Ceuta and Melilla: never ask the runtime for it.
const EURO_AREA = { es: 'Zona euro', en: 'Euro area', pt: 'Zona do euro' };

// Country names in the language of the interface (the hub constants only carry Spanish names).
// Falls back to the given name when the runtime has no region names for the language.
export function countryDisplayName(iso, language, fallback) {
  if (String(iso || '').toUpperCase() === 'EA') return EURO_AREA[String(language || 'es').slice(0, 2)] || EURO_AREA.es;
  try {
    const name = new Intl.DisplayNames([language || 'es'], { type: 'region' }).of(iso);
    if (name && name !== iso) return name;
  } catch (e) {
    // older runtimes: use the fallback
  }
  return fallback || iso;
}
